import { Grid, Paper } from '@mui/material';
import { Outlet } from 'react-router-dom';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';
import { SelectableItem } from 'src/shared/models/gui/selectableItem';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { useState, useEffect } from 'react';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { District } from 'src/shared/models/user';
import { getDistrictById } from 'src/shared/services/districtService';
import { useTranslation } from 'react-i18next';
import { useGlobals } from 'src/shared/contexts/appContext';
import DistrictPageTabNavigation from '../components/districtPageTabNavigation';

export const MyDistrictPage = () => {
  const { t } = useTranslation(['common']);
  const [, setLoading] = useState<boolean>(false);
  const { currentUser } = useGlobals();

  const isMounted = useIsMounted();

  const [district, setDistrict] = useState<District>();

  const currentDistrictId = `${currentUser?.districts[0].countyAss_id}`;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const result = await getDistrictById(currentDistrictId);
        if (isMounted()) {
          setDistrict(result.data);
        }
      } catch (e) {
        if (isMounted()) ConsoleHelper.log(e);
      } finally {
        if (isMounted()) setLoading(false);
      }
    };
    if (currentUser && currentDistrictId) {
      fetchData();
    }
  }, [isMounted, currentUser, currentDistrictId]);

  if (!currentUser) return null;

  const districtPageTabs: SelectableItem[] = [
    {
      label: t('common:organization.pageTabs.form'),
      value: `${RoutesEnum.OrganizationMyDistrict}`,
    },
    {
      label: t('common:organization.pageTabs.board'),
      value: `${RoutesEnum.OrganizationMyDistrict}/styrelse`,
    },
    {
      label: t('common:organization.pageTabs.elected'),
      value: `${RoutesEnum.OrganizationMyDistrict}/fortroendevalda`,
    },
    {
      label: t('common:organization.pageTabs.users'),
      value: `${RoutesEnum.OrganizationMyDistrict}/users`,
    },
  ];

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <MainContentHeader title={district?.countyAss ?? ''} />
      </Grid>
      <Grid item xs={12}>
        <Paper>
          <DistrictPageTabNavigation tabs={districtPageTabs} />
          <Outlet />
        </Paper>
      </Grid>
    </Grid>
  );
};
